/**
 * Thrown by useUpdateDesignProject when the design project no longer exists
 * (project_not_found) and the server asked us to redirect — e.g. the project was
 * deleted in another tab mid save/add-to-cart. It replaces the old
 * `new Promise(() => {})` hang: awaiters now reject fast instead of freezing
 * forever (MN-10713). It is an expected control-flow signal, NOT a failure, so it
 * is intentionally never reported to Honeybadger; the redirect (PR #61149's
 * dead-project flash contract) owns the navigation, and save handlers catch/ignore it.
 */
export class ProjectNotFoundRedirectError extends Error {
  constructor(message = "Design project not found; redirecting.") {
    super(message);
    this.name = "ProjectNotFoundRedirectError";
  }
}
